<template>
  <div v-loading="fullLoading">
    <el-row>
      <el-col :span="24">
        <el-table :data="sysStatusTable" stripe style="width: 100%; margin-bottom: 10px; font-size: 1rem"
          @cell-click="sysStatusClick">
          <el-table-column prop="outdoorTemperature" label="Outside Air Temperature"></el-table-column>
          <el-table-column prop="motorCurrentPosition" label="Motor Current Position"></el-table-column>
          <el-table-column prop="motorTargetPosition" label="Motor Target Position"></el-table-column>
          <el-table-column prop="compensator" label="Compensator">
            <template slot-scope="scope">
              <el-button type="text" @click="dialogVisible = true">{{ scope.row.compensator }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="sysHeatStatusTable" stripe style="width: 100%; margin-bottom: 10px"
          @cell-click="sysOperationClick">
          <el-table-column prop="mode" label="Mode">
            <template slot-scope="scope">
              <el-button type="text">{{ scope.row.mode }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="Operation"></el-table-column>
          <el-table-column prop="period" label="Period"></el-table-column>
          <el-table-column prop="network" label="Network"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-table :data="temperatureSensorsTable" stripe style="width: 100%; margin-bottom: 10px">
          <el-table-column prop="sensor" label="Temperature Sensor"></el-table-column>
          <el-table-column prop="value" label="Current Reading"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="12">
        <div style="margin-bottom: 10px; margin-left: 10px">
          <el-table :data="pressureSensorsTable" stripe>
            <el-table-column prop="sensor" label="Pressure Sensor"></el-table-column>
            <el-table-column prop="value" label="Current Reading">
              <template slot-scope="scope">
                <div v-if="scope.row.sensor == 'Differential' && scope.row.raw < 0" style="color: red">{{
                    scope.row.value
                }}</div>
                <div v-else>{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div style="margin-bottom: 10px">
          <el-table :data="heatBalancerTable" stripe>
            <el-table-column prop="apartmentAverage" label="Heat Balancer"></el-table-column>
            <el-table-column prop="valueBottom" label="HB Bottom"></el-table-column>
            <el-table-column prop="valueTop" label="HB Top"></el-table-column>
            <el-table-column prop="valueDifference" label="HB Difference"></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <!-- Apartment Data -->
    <el-row style="margin:top:10px" v-if="apartmentSensorsAvailable">
      <el-col :span="24">
        <el-table :data="apartmentSensorMetrics" stripe style="width: 100%; margin-bottom: 10px">
          <el-table-column prop="average" label="Apartments Average"></el-table-column>
          <el-table-column prop="totalSensors" label="Total Sensor"></el-table-column>
          <el-table-column prop="onlineSensors" label="Online"></el-table-column>
          <el-table-column prop="networkHealth" label="Network Health"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- Apartment Data End -->
    <el-row style="margin:top:10px">
      <el-col :span="16">
        <div>
          <el-table :data="outputTable" stripe style="width: 100%">
            <el-table-column prop="name" label="Output"></el-table-column>
            <el-table-column label="Control">
              <template scope="scope">
                <el-switch v-model="scope.row.control" on-text="Manual" off-text="Auto" :width="80"
                  @click.native.prevent="digitalOutputControlValue($event, scope.row.name)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="value" width="150">
              <template scope="scope">
                <el-switch v-model="scope.row.value" :disabled="!scope.row.control"
                  @click.native.prevent="digitalOutputManualValue($event, scope.row.name)"></el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="8">
        <div style="margin-left: 20px">
          <el-table :data="inputTable" stripe style="width: 100%">
            <el-table-column prop="name" label="Input"></el-table-column>
            <el-table-column label="State" width="150">
              <template scope="scope">
                <el-switch v-model="scope.row.value" :disabled="true"></el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-row style="margin:top:10px">
      <el-dialog :title="editDialog.title" :visible.sync="editDialog.visible" width="150px">
        <div v-loading="editDialog.loading">
          <span style="font-size: 1.5rem">Current Value : {{ editDialog.currentValue }}</span>
          <el-input placeholder="New Value" v-model="editDialog.value" type="number" style="margin-top: 10px"
            @keyup.enter.native="editDialogHandler"></el-input>
          <el-button type="primary" style="margin-top: 10px" @click="editDialog.visible = false">Cancel</el-button>
          <el-button type="primary" style="margin-top: 10px" @click="editDialogHandler">Save to Panel</el-button>
        </div>
      </el-dialog>
      <!--Mode requires a special dialog-->
      <el-dialog title="Mode" :visible.sync="modeDialog.visible">
        <el-form :model="modeDialog.form" v-loading="modeDialog.loading" @submit.native.prevent>
          <el-form-item>
            <el-radio-group v-model="modeDialog.form.mode" size="large" @change="modeDialogChangeValue">
              <el-radio-button label="Auto">Auto</el-radio-button>
              <el-radio-button label="ValveSet">Manual</el-radio-button>
              <el-radio-button label="Manual">Valve Set</el-radio-button>
              <el-radio-button label="Program Mode">Program Mode</el-radio-button>
              <el-radio-button label="Pause">Pause</el-radio-button>
              <el-radio-button label="Off">Off</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <div v-visible="modeDialog.valveSetOptionsVisible">
              <el-radio-group v-show="modeDialog.valveSetOptionsVisible" v-model="modeDialog.form.valveSet"
                size="large">
                <el-radio-button label="Closed">Closed</el-radio-button>
                <el-radio-button label="Open">Open</el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item>
            <div v-visible="modeDialog.manualSetOptionsVisible">
              <span style="font-size: 1.5rem">Current Value : {{ modeDialog.form.currentManualPosition }}</span>
              <el-input placeholder="New Value" v-model="modeDialog.form.manualPosition" type="number"
                style="margin-top: 10px" @keyup.enter.native="modeDialogHandler"></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-top: 10px" @click="modeDialog.visible = false">Cancel</el-button>
            <el-button type="primary" style="margin-top: 10px" @click="modeDialogHandler">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import Axios from "axios"
import IOService from "@/api/io.service"
import numkeyboard from "vue-numkeyboard"
import constants from "@/common/constants/system"
import SettingsService from "@/api/settings.service"
import ApartmentsService from "@/api/apartments.service"

export default {
  components: {},
  props: {},
  data() {
    return {
      polling: null,
      user: this.$session.get("User"),
      fullLoading: false,
      adminLock: false,
      modeDialog: {
        visible: false,
        form: {
          mode: "ValveSet",
          valveSet: "Closed",
          manualPosition: "",
          currentManualPosition: ""
        },
        valveSetOptionsVisible: false,
        manualSetOptionsVisible: false,
        timeout: 0,
        loading: false
      },
      editDialog: {
        visible: false,
        loading: false,
        value: "",
        title: "",
        currentValue: "",
        timeout: 0
      },

      sysHeatStatusTable: [
        {
          mode: "Auto",
          operation: "Winter",
          period: "Heatup",
          network: "Connected"
        }
      ],
      apartmentSensorsAvailable: false,
      apartmentSensorMetrics: [
        {
          average: "75 F",
          totalSensors: 30,
          onlineSensors: 28,
          networkHealth: "95%"
        }
      ],
      heatBalancerTable: [
        {
          none: "",
          valueBottom: "",
          valueTop: "",
          valueDifference: ""
        }
      ],
      temperatureSensorsTable: [
        {
          sensor: "Return Line",
          value: ""
        },
        {
          sensor: "Domestic Water",
          value: ""
        },
        {
          sensor: "Stack",
          value: ""
        },
        {
          sensor: "Aux",
          value: ""
        }
      ],
      pressureSensorsTable: [
        {
          sensor: "Boiler",
          value: ""
        },
        {
          sensor: "Supply",
          value: ""
        },
        {
          sensor: "Return",
          value: ""
        },
        {
          sensor: "Differential",
          value: ""
        }
      ],
      sysStatusTable: [
        {
          outdoorTemperature: "",
          motorCurrentPosition: "",
          motorTargetPosition: "",
          compensator: ""
        }
      ],
      dataLoaded: false,
      motorCurrentPosition: 0,
      motorTargetPosition: 0,
      compensatorValue: -2,
      supplyPressureValue: 4,
      boilerPressureValue: -15,
      outputTable: [
        {
          name: "Boiler",
          control: false,
          value: false
        },
        {
          name: "Vacuum Pump",
          control: false,
          value: false
        },
        {
          name: "Differential",
          control: false,
          value: false
        },
        {
          name: "Flood Alarm",
          control: false,
          value: false
        }
      ],
      inputTable: [
        {
          name: "Air Pump 1",
          value: false
        },
        {
          name: "Air Pump 2",
          value: false
        },
        {
          name: "Condensate 1",
          value: false
        },
        {
          name: "Condensate 2",
          value: false
        }
      ]
    }
  },
  methods: {
    toFahrenheit(degC) {
      console.log(degC)
      if (typeof degC === "undefined") {
        return ""
      } else {
        return (degC * (9 / 5) + 32).toFixed(1) + "°F"
      }
    },
    modeDialogChangeValue(data) {
      if (data == "ValveSet") {
        this.modeDialog.valveSetOptionsVisible = true
      } else {
        this.modeDialog.valveSetOptionsVisible = false
      }
      if (data == "Manual") {
        this.modeDialog.manualSetOptionsVisible = true
      } else {
        this.modeDialog.manualSetOptionsVisible = false
      }
    },
    sysOperationClick(row, column, cell, event) {
      if (column.property == "mode") {
        this.modeDialog.visible = true
        if (this.modeDialog.form.mode == "ValveSet") this.modeDialog.valveSetOptionsVisible = true
        else if (this.modeDialog.form.mode == "Manual") this.modeDialog.manualSetOptionsVisible = true
        this.modeDialog.form.manualPosition = ""
      }
    },
    sysStatusClick(row, column, cell, event) {
      if (column.property == "compensator") {
        this.editDialog.title = "Compensator"
        this.editDialog.visible = true
        this.editDialog.value = ""
        this.editDialog.currentValue = this.sysStatusTable[0].compensator
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    checkCompensator() {
      this.getData()
      this.editDialog.timeout--
      if (this.editDialog.timeout <= 0) {
        this.editDialog.visible = false
        this.editDialog.loading = false
        const h = this.$createElement
        this.$notify({
          title: "Compensator",
          message: "Error trying to save setting to panel",
          type: "error"
        })
      } else if (this.editDialog.value != this.sysStatusTable[0].compensator) {
        setTimeout(this.checkCompensator, 500)
      } else {
        this.editDialog.visible = false
        this.editDialog.loading = false
      }
    },
    editDialogHandler() {
      if (this.editDialog.title == "Compensator") {
        if (this.editDialog.value < constants.COMPENSATOR.min || this.editDialog.value > constants.COMPENSATOR.max || isNaN(parseInt(this.editDialog.value))) {
          const h = this.$createElement
          this.$notify({
            title: "Compensator",
            message: "Compensator value should be betweeen " + constants.COMPENSATOR.min + " and " + constants.COMPENSATOR.max,
            type: "warning"
          })
        } else {
          this.editDialog.loading = true
          Axios.all([SettingsService.changeSetting(this.user.activeZone, "Settings.Compensator.Value", this.editDialog.value)]).then(
            Axios.spread((changeSettingResponse) => {
              //The system should update in 10 seconds.
              if (changeSettingResponse.data.result != "success") {
                this.editDialog.loading = false
                const h = this.$createElement
                this.$notify({
                  title: "Compensator",
                  message: "Error trying to save setting to panel",
                  type: "error"
                })
              } else {
                setTimeout(() => {
                  this.editDialog.visible = false
                  this.editDialog.loading = false
                  this.getData()
                }, 5000)
              }
            })
          )
        }
      }
    },
    checkModeOnly() {
      this.getData()
      this.modeDialog.timeout--
      if (this.modeDialog.timeout <= 0) {
        this.modeDialog.visible = false
        this.modeDialog.loading = false
        const h = this.$createElement
        this.$notify({
          title: "Mode",
          message: "Error trying to save mode to panel",
          type: "error"
        })
      } else if (this.modeDialog.form.mode != this.sysHeatStatusTable[0].mode) {
        setTimeout(this.checkModeOnly, 500)
      } else {
        this.modeDialog.visible = false
        this.modeDialog.loading = false
      }
    },
    modeDialogHandler(data) {
      //We check what mode state we are in.
      switch (this.modeDialog.form.mode) {
        case "Auto":
        case "Program Mode":
        case "Pause":
        case "Off":
          this.modeDialog.loading = true
          Axios.all([SettingsService.changeSetting(this.user.activeZone, "Settings.Mode.Value", this.modeDialog.form.mode)]).then(
            Axios.spread((changeSettingResponse) => {
              //The system should update in 10 seconds.
              if (changeSettingResponse.data.result != "success") {
                this.modeDialog.loading = false
                const h = this.$createElement
                this.$notify({
                  title: "Mode",
                  message: "Error trying to save mode to panel",
                  type: "error"
                })
              } else {
                setTimeout(() => {
                  this.modeDialog.visible = false
                  this.modeDialog.loading = false
                  this.getData()
                }, 5000)
              }
            })
          )
          break
        case "ValveSet":
          this.modeDialog.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Mode.Value", this.modeDialog.form.mode),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Mode.ValveSet.Value", this.modeDialog.form.valveSet)
          ]).then(
            Axios.spread((changeSettingResponse, changeValveSetResponse) => {
              //The system should update in 10 seconds.
              //this.modeDialog.timeout = 20;
              //this.checkModeOnly();
              if (changeSettingResponse.data.result != "success" && changeValveSetResponse.data.result != "success") {
                this.modeDialog.loading = false
                const h = this.$createElement
                this.$notify({
                  title: "Mode",
                  message: "Error trying to save mode to panel",
                  type: "error"
                })
              } else {
                setTimeout(() => {
                  this.modeDialog.visible = false
                  this.modeDialog.loading = false
                  this.getData()
                }, 5000)
              }
            })
          )
          break
        case "Manual":
          this.modeDialog.loading = true
          if (this.modeDialog.form.manualPosition == "") {
            this.modeDialog.form.manualPosition = this.modeDialog.form.currentManualPosition
          }
          if (parseFloat(this.modeDialog.form.manualPosition) < constants.MOTOR_MANUAL_POSITION.min || parseFloat(this.modeDialog.form.manualPosition) > constants.MOTOR_MANUAL_POSITION.max) {
            const h = this.$createElement

            this.$notify({
              title: "Valve Set Position",
              message: "Valve Set Position should be between " + constants.MOTOR_MANUAL_POSITION.min + " and " + constants.MOTOR_MANUAL_POSITION.max,
              type: "warning"
            })
            this.modeDialog.loading = false
          } else {
            Axios.all([
              SettingsService.changeSetting(this.user.activeZone, "Settings.Mode.Value", this.modeDialog.form.mode),
              SettingsService.changeSetting(this.user.activeZone, "Settings.Mode.Manual.Value", this.modeDialog.form.manualPosition)
            ]).then(
              Axios.spread((changeSettingResponse, changeValveSetResponse) => {
                //The system should update in 10 seconds.
                //this.modeDialog.timeout = 20;
                //this.checkModeOnly();
                if (changeSettingResponse.data.result != "success" && changeValveSetResponse.data.result != "success") {
                  this.modeDialog.loading = false
                  const h = this.$createElement
                  this.$notify({
                    title: "Mode",
                    message: "Error trying to save mode to panel",
                    type: "error"
                  })
                } else {
                  setTimeout(() => {
                    this.modeDialog.visible = false
                    this.modeDialog.loading = false
                    this.getData()
                  }, 5000)
                }
              })
            )
          }
          break
      }
    },
    onSubmit() {
      console.log("submit!")
    },
    printTemperature(result, enabled) {
      if (enabled) {
        if (result == -500) return "Error"
        else return result + "°F"
      } else {
        return "Disabled"
      }
    },
    printPressure(result, enabled) {
      if (enabled) {
        //Pressure is stored in PSI but printed in PSI or inHG for vacuum
        if (result == -500) return "Error"
        if (result >= 0) return result.toFixed(1) + " PSI"
        else return (result * -1 * 2.03602).toFixed(1) + " inHg"
      } else {
        return "Disabled"
      }
    },
    printPressurePSI(result, enabled) {
      if (enabled) {
        //Pressure is stored in PSI but printed in PSI or inHG for vacuum
        if (result == -500) return "Error"
        else if (result > 0) return "+" + result.toFixed(1) + " PSI"
        else return result.toFixed(1) + " PSI"
      } else {
        return "Disabled"
      }
    },
    printPressureInHG(result, enabled) {
      if (enabled) {
        //Pressure is stored in PSI but printed in PSI or inHG for vacuum
        if (result == -500) return "Error"
        else if (result > 0) return "+" + (result * 2.03602).toFixed(1) + " inHg"
        else return (result * 2.03602).toFixed(1) + " inHg"
      } else {
        return "Disabled"
      }
    },
    getData() {
      if (!this.$auth.isAuthenticated()) this.$auth.login()
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([
        IOService.getIO(this.user.activeZone),
        IOService.getApartmentAverage(this.user.activeZone),
        IOService.getSettings(this.user.activeZone),
        IOService.getOperationStatus(this.user.activeZone),
        ApartmentsService.getApartmentsMetrics(this.user.activeZone)
        // SettingsService.getOperationStatus(),
      ])
        .then(
          Axios.spread((IOResponse, ApartmentAverageResponse, SettingsResponse, OperationStatusResponse, ApartmentsMetrics) => {
            if (typeof IOResponse.data.error !== "undefined") {
              this.sysHeatStatusTable[0].network = "Panel Disconnected"
              return
            } else {
              this.sysHeatStatusTable[0].network = "Panel Connected"
            }

            this.sysStatusTable[0].outdoorTemperature = this.printTemperature(IOResponse.data.sensors.temperature.outdoor.toFixed(1), true)
            this.sysStatusTable[0].motorCurrentPosition = IOResponse.data.motor.currentPosition.toFixed(0) + "%"
            this.sysStatusTable[0].motorTargetPosition = IOResponse.data.motor.targetPosition.toFixed(0) + "%"

            this.temperatureSensorsTable[0].value = this.printTemperature(
              IOResponse.data.sensors.temperature.returnLine.toFixed(1),
              SettingsResponse.data.sensors.temperature.returnLine.enabled == "true"
            )
            this.temperatureSensorsTable[1].value = this.printTemperature(
              IOResponse.data.sensors.temperature.domesticWater.toFixed(1),
              SettingsResponse.data.sensors.temperature.domesticWater.enabled == "true"
            )
            this.temperatureSensorsTable[2].value = this.printTemperature(IOResponse.data.sensors.temperature.stack.toFixed(1), SettingsResponse.data.sensors.temperature.stack.enabled == "true")
            this.temperatureSensorsTable[3].value = this.printTemperature(IOResponse.data.sensors.temperature.aux.toFixed(1), SettingsResponse.data.sensors.temperature.aux.enabled == "true")

            //boiler supply, return differential
            this.pressureSensorsTable[0].value = this.printPressurePSI(IOResponse.data.sensors.pressure.boiler, SettingsResponse.data.sensors.pressure.boiler.enabled == "true")
            this.pressureSensorsTable[1].value = this.printPressureInHG(IOResponse.data.sensors.pressure.supply, SettingsResponse.data.sensors.pressure.supply.enabled == "true")
            this.pressureSensorsTable[2].value = this.printPressureInHG(IOResponse.data.sensors.pressure.return, SettingsResponse.data.sensors.pressure.return.enabled == "true")

            var differentialPossible = SettingsResponse.data.sensors.pressure.supply.enabled == "true" && SettingsResponse.data.sensors.pressure.return.enabled == "true"
            if (differentialPossible) {
              if (IOResponse.data.sensors.pressure.supply != -500 || IOResponse.data.sensors.pressure.return != -500) {
                this.pressureSensorsTable[3].value = this.printPressureInHG(IOResponse.data.sensors.pressure.supply - IOResponse.data.sensors.pressure.return, differentialPossible)
                this.pressureSensorsTable[3].raw = IOResponse.data.sensors.pressure.supply - IOResponse.data.sensors.pressure.return
              } else {
                this.pressureSensorsTable[3].value = "Error"
              }
            }

            console.log(SettingsResponse.data)
            console.log(ApartmentAverageResponse.data)

            // this.heatBalancerTable[0].apartmentAverage = this.printTemperature(
            //   parseFloat(ApartmentAverageResponse.data.apartmentAverage).toFixed(1),
            //   ApartmentAverageResponse.data.apartmentAverage != "NA"
            // )

            this.heatBalancerTable[0].valueBottom = this.printTemperature(
              IOResponse.data.sensors.temperature.heatBalancer.bottom.toFixed(1),
              SettingsResponse.data.sensors.temperature.heatBalancer.enabled == "true"
            )
            this.heatBalancerTable[0].valueTop = this.printTemperature(
              IOResponse.data.sensors.temperature.heatBalancer.top.toFixed(1),
              SettingsResponse.data.sensors.temperature.heatBalancer.enabled == "true"
            )
            this.heatBalancerTable[0].valueDifference = this.printTemperature(
              (IOResponse.data.sensors.temperature.heatBalancer.top - IOResponse.data.sensors.temperature.heatBalancer.bottom).toFixed(1),
              SettingsResponse.data.sensors.temperature.heatBalancer.enabled == "true"
            )

            this.outputTable[0].control = SettingsResponse.data.digitalOutputs.boiler.control == "Manual"
            this.outputTable[1].control = SettingsResponse.data.digitalOutputs.vacuumPump.control == "Manual"
            this.outputTable[2].control = SettingsResponse.data.digitalOutputs.differential.control == "Manual"
            this.outputTable[3].control = SettingsResponse.data.digitalOutputs.floodAlarm.control == "Manual"
            console.log(IOResponse.data)
            if (SettingsResponse.data.digitalOutputs.boiler.control == "Manual") this.outputTable[0].value = SettingsResponse.data.digitalOutputs.boiler.manualState == "true"
            else this.outputTable[0].value = IOResponse.data.digitalOutputs.boiler == "true"

            if (SettingsResponse.data.digitalOutputs.vacuumPump.control == "Manual") this.outputTable[1].value = SettingsResponse.data.digitalOutputs.vacuumPump.manualState == "true"
            else this.outputTable[1].value = IOResponse.data.digitalOutputs.vacuum == "true"

            if (SettingsResponse.data.digitalOutputs.differential.control == "Manual") this.outputTable[2].value = SettingsResponse.data.digitalOutputs.differential.manualState == "true"
            else this.outputTable[2].value = IOResponse.data.digitalOutputs.differential == "true"

            if (SettingsResponse.data.digitalOutputs.floodAlarm.control == "Manual") this.outputTable[3].value = SettingsResponse.data.digitalOutputs.floodAlarm.manualState == "true"
            else this.outputTable[3].value = IOResponse.data.digitalOutputs.floodAlarm == "true"

            this.inputTable[0].value = IOResponse.data.digitalInputs.airPump_1 == "true"
            this.inputTable[1].value = IOResponse.data.digitalInputs.airPump_2 == "true"
            this.inputTable[2].value = IOResponse.data.digitalInputs.condensate_1 == "true"
            this.inputTable[3].value = IOResponse.data.digitalInputs.condensate_2 == "true"

            if (!this.modeDialog.visible) {
              this.modeDialog.form.currentManualPosition = SettingsResponse.data.mode.manual.value
              this.modeDialog.form.valveSet = SettingsResponse.data.mode.valveSet.value
              this.modeDialog.form.mode = SettingsResponse.data.mode.value
            }

            //if (!this.editDialog.visible) {
            this.sysStatusTable[0].compensator = SettingsResponse.data.compensator.value
            //}

            switch (SettingsResponse.data.mode.value) {
              case "Auto":
              case "Program Mode":
              case "Pause":
              case "Off":
                this.sysHeatStatusTable[0].mode = SettingsResponse.data.mode.value
                break
              case "Manual":
                this.sysHeatStatusTable[0].mode = "Valve Set"
                break
              case "ValveSet":
                this.sysHeatStatusTable[0].mode = "Manual"
                break
            }
            this.sysHeatStatusTable[0].operation = OperationStatusResponse.data.operation.season
            this.sysHeatStatusTable[0].period = OperationStatusResponse.data.operation.period

            //Apartments
            //console.log(ApartmentsMetrics)
            if (ApartmentsMetrics.data != null && ApartmentsMetrics.data.totalSensors > 0) {
              this.apartmentSensorsAvailable = true
              this.apartmentSensorMetrics[0].average = this.toFahrenheit(ApartmentsMetrics.data.temperatureAverage)
              this.apartmentSensorMetrics[0].totalSensors = ApartmentsMetrics.data.totalSensors
              this.apartmentSensorMetrics[0].onlineSensors = ApartmentsMetrics.data.totalSensorsOnline
              this.apartmentSensorMetrics[0].networkHealth = ((ApartmentsMetrics.data.totalSensorsOnline / ApartmentsMetrics.data.totalSensors) * 100).toFixed(0) + "%"
            } else {
              this.apartmentSensorsAvailable = false
            }

            this.dataLoaded = true
          })
        )
        .catch((err) => {
          this.sysHeatStatusTable[0].network = "Error in Server and/or Panel"
          console.log(err)
        })
    },
    digitalOutputControl(event, id) {
      switch (id) {
        case "Boiler":
          //SettingsService.setPersistedValue('Settings.DigitalOutputs.Boiler.Control', event ? 'Manual' : 'Auto');
          break
        case "Vacuum Pump":
          //SettingsService.setPersistedValue('Settings.DigitalOutputs.VacuumPump.Control', event ? 'Manual' : 'Auto');
          break
        case "Differential":
          //SettingsService.setPersistedValue('Settings.DigitalOutputs.Differential.Control', event ? 'Manual' : 'Auto');
          break
        case "Flood Alarm":
          //SettingsService.setPersistedValue('Settings.DigitalOutputs.FloodAlarm.Control', event ? 'Manual' : 'Auto');
          break
      }
    },

    checkDigitalOutput(key, value, timeout) {
      this.getData()
      timeout--
      if (timeout <= 0) {
        this.fullLoading = false
        const h = this.$createElement
        this.$notify({
          title: "Digital Outputs",
          message: "Error trying to save mode to panel",
          type: "error"
        })
      } else {
        switch (key) {
          case "Settings.DigitalOutputs.Boiler.Control":
            if (this.outputTable[0].control == value) {
              this.fullLoading = false
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout)
            }
            break
          case "Settings.DigitalOutputs.VacuumPump.Control":
            if (this.outputTable[1].control == value) {
              this.fullLoading = false
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout)
            }
            break
          case "Settings.DigitalOutputs.Differential.Control":
            if (this.outputTable[2].control == value) {
              this.fullLoading = false
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout)
            }
            break
          case "Settings.DigitalOutputs.FloodAlarm.Control":
            if (this.outputTable[3].control == value) {
              this.fullLoading = false
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout)
            }
            break
          case "Settings.DigitalOutputs.Boiler.ManualState":
            if (this.outputTable[0].value == value) {
              this.fullLoading = false
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout)
            }
            break
          case "Settings.DigitalOutputs.VacuumPump.ManualState":
            if (this.outputTable[1].value == value) {
              this.fullLoading = false
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout)
            }
            break
          case "Settings.DigitalOutputs.Differential.ManualState":
            if (this.outputTable[2].value == value) {
              this.fullLoading = false
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout)
            }
            break
          case "Settings.DigitalOutputs.FloodAlarm.ManualState":
            if (this.outputTable[3].value == value) {
              this.fullLoading = false
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout)
            }
            break
        }
      }
    },

    digitalOutputControlValue(event, id) {
      if (this.user.role == "buildingAdmin") return
      var key = ""
      var value = false
      switch (id) {
        case "Boiler":
          key = "Settings.DigitalOutputs.Boiler.Control"
          value = !this.outputTable[0].control
          break
        case "Vacuum Pump":
          key = "Settings.DigitalOutputs.VacuumPump.Control"
          value = !this.outputTable[1].control
          break
        case "Differential":
          key = "Settings.DigitalOutputs.Differential.Control"
          value = !this.outputTable[2].control
          break
        case "Flood Alarm":
          key = "Settings.DigitalOutputs.FloodAlarm.Control"
          value = !this.outputTable[3].control
          break
      }

      console.log(key + "-" + value)
      this.fullLoading = true
      Axios.all([SettingsService.changeSetting(this.user.activeZone, key, value ? "Manual" : "Auto")])
        .then(
          Axios.spread((settingChangeResponse) => {
            //The system should update in 10 seconds.
            if (settingChangeResponse.data.result != "success") {
              this.fullLoading = false
              const h = this.$createElement
              this.$notify({
                title: "Digital Output",
                message: "Error trying to save data to panel",
                type: "error"
              })
            } else {
              this.checkDigitalOutput(key, value, 20)
            }
          })
        )
        .catch(() => {
          this.fullLoading = false
          const h = this.$createElement
          this.$notify({
            title: "Digital Output",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },
    digitalOutputManualValue(event, id) {
      if (this.user.role == "buildingAdmin") return
      var key = ""
      var value = false
      switch (id) {
        case "Boiler":
          if (!this.outputTable[0].control) return
          key = "Settings.DigitalOutputs.Boiler.ManualState"
          value = !this.outputTable[0].value
          break
        case "Vacuum Pump":
          if (!this.outputTable[1].control) return
          key = "Settings.DigitalOutputs.VacuumPump.ManualState"
          value = !this.outputTable[1].value
          break
        case "Differential":
          if (!this.outputTable[2].control) return
          key = "Settings.DigitalOutputs.Differential.ManualState"
          value = !this.outputTable[2].value
          break
        case "Flood Alarm":
          if (!this.outputTable[3].control) return
          key = "Settings.DigitalOutputs.FloodAlarm.ManualState"
          value = !this.outputTable[3].value
          break
      }

      console.log(key + "-" + value)
      this.fullLoading = true
      Axios.all([SettingsService.changeSetting(this.user.activeZone, key, value ? "true" : "false")])
        .then(
          Axios.spread((settingChangeResponse) => {
            //The system should update in 10 seconds.
            if (settingChangeResponse.data.result != "success") {
              this.fullLoading = false
              const h = this.$createElement
              this.$notify({
                title: "Digital Output",
                message: "Error trying to save data to panel",
                type: "error"
              })
            } else {
              this.checkDigitalOutput(key, value, 20)
            }
          })
        )
        .catch(() => {
          this.fullLoading = false
          const h = this.$createElement
          this.$notify({
            title: "Digital Output",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    }
  },
  created() { },
  mounted() {
    this.getData()
    this.polling = setInterval(this.getData, 10000)
  },
  beforeDestroy() {
    clearInterval(this.polling)
  }
}
</script>

<style>
.el-table td {
  font-size: medium;
}

.el-table__body-wrapper {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?b2722092